__turbopack_context__.v({
  "shareButtonWrapper": "PW0ama_shareButtonWrapper",
  "sharePopover": "PW0ama_sharePopover",
});
